export default {
  services: [],
  serviceTypes: [],
  selectedService: {},
  servicesCount: 0
}
